<template>
  <form @submit.prevent="onSubmit">
    <fieldset :disabled="isSubmitting" :class="{ 'divide-opacity-50': isSubmitting }">
      <legend class="sr-only">Contact form</legend>
        <input id="type" name="type" type="hidden" v-model="type">

        <div class="flex flex-col lg:flex-row">
          <div class="w-full lg:w-1/2 lg:mr-2 mb-10">
            <label
              class="text-xs uppercase tracking-widest mb-3"
              for="name"
            >Name</label>
            <input
              class="w-full px-2 py-4 font-light text-xl tracking-normal border-b-2 border-white bg-transparent border-opacity-50 focus:border-opacity-100 focus:outline-none"
              type="text"
              id="name"
              name="name"
              placeholder="Your name..."
              v-model="name"
              required
            />
            <template v-if="hasError('name')">
              <p
                v-for="message in errors.name"
                :key="name + message"
                class="text-xs text-coral uppercase tracking-widest mb-3 my-5"
              >{{ message }}</p>
            </template>
          </div>

          <div class="w-full lg:w-1/2 lg:ml-2 mb-10">
            <label
              class="text-xs uppercase tracking-widest mb-3"
              for="email"
            >Email</label>
            <input
              class="w-full px-2 py-4 font-light text-xl tracking-normal border-b-2 border-white bg-transparent border-opacity-50 focus:border-opacity-100 focus:outline-none"
              type="email"
              id="email"
              name="email"
              placeholder="Email address..."
              v-model="email"
              required
            />
            <template v-if="hasError('email')">
              <p
                v-for="message in errors.email"
                :key="email + message"
                class="text-xs text-coral uppercase tracking-widest mb-3 my-5"
              >{{ message }}</p>
            </template>
          </div>
        </div>

        <label
          class="text-xs uppercase tracking-widest mb-3"
          for="message"
        >Message</label>
        <textarea
          class="w-full px-2 py-4 font-light text-xl tracking-normal border-b-2 border-white bg-transparent border-opacity-50 focus:border-opacity-100 focus:outline-none"
          id="message"
          name="message"
          placeholder="Your message..."
          v-model="message"
        ></textarea>
        <template v-if="hasError('message')">
          <p
            v-for="message in errors.message"
            :key="message + message"
            class="text-xs text-coral uppercase tracking-widest mb-3 my-5"
          >{{ message }}</p>
        </template>

      <template v-if="hasError('error')">
        <div class="">
          <p class="text-xs text-coral uppercase tracking-widest mb-3 my-5" v-for="message in errors.error" :key="errors.error + message">{{ message }}</p>
        </div>
      </template>

      <button
        type="submit"
        class="button mt-10"
        :class="{'opacity-50': isSubmitting, '': submitSuccess}"
      >{{ submitSuccess ? 'Message sent' : 'Send message' }}</button>
    </fieldset>

    <!-- <div v-if="successMessage" class="">
      {{ successMessage }}
    </div> -->
  </form>
</template>

<script>
import Route from '../src/Route';
import get from 'lodash/get';

export default {
  data() {
    return {
      name: null,
      email: null,
      message: null,
      type: 'contact',
      errors: null,
      isSubmitting: false,
      submitSuccess: false,
      // successMessage: null,
    };
  },

  computed: {
    postMessage() {
      return {
        type: this.type,
        email: this.email,
        message: this.message,
        data: {
          name: this.name,
        }
      };
    },
  },

  methods: {
    hasError(name) {
      if (!this.errors) {
        return false;
      }

      return typeof this.errors[name] !== 'undefined';
    },

    clearform() {
      this.errors = null;
      this.name = null;
      this.email = null;
      this.message = null;
      this.submitSuccess = false;
    },

    setSuccess() {
      this.submitSuccess = true;
      setTimeout(() => {
        this.clearform();
      }, 3000);
    },

    onSubmit() {
      this.isSubmitting = true;

      axios
        .post('/newsletters', this.postMessage)
        .then((response) => {
          if (response.status === 200) {
            // console.log(response.data);
            // this.successMessage = response.data.message;
            this.setSuccess();
            return;
          }

          throw 'There was a problem.';
        })
        .catch((error) => {
          // console.log(error);
          let status = get(error, 'response.status');

          switch (status) {
            case 422:
              this.errors = error.response.data;
              break;
            case 500:
              this.errors = { error: ['There was a problem. Please try again.'] };
              break;
            case null:
            default:
              this.errors = { error: [error] };
              break;
          }
        })
        .then(() => {
          this.isSubmitting = false;
        });
    },
  },
};
</script>
